// Константы приложения
import { env } from "../env";

export { SIMULATOR_MOBILE_COMPACT_CLASS } from "./simulatorMobile";

// Базовый URL Backend API (централизованно берётся из env)
export const API_HOST = env.API_HOST;

export const SECRET_KEY = "my_super_secret_key";

/**
 * Формирует URL для загрузки фото профиля через прокси-эндпоинт.
 * @param filePath - путь к файлу в Telegram (например, "photos/file_123.jpg")
 * @returns URL к прокси-эндпоинту или null, если filePath не передан
 */
export function getTelegramPhotoUrl(filePath: string | null | undefined): string | null {
  if (!filePath) {
    return null;
  }
  
  // Если это уже полный URL (для обратной совместимости), возвращаем как есть
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
    return filePath;
  }
  
  // Формируем URL к прокси-эндпоинту
  const encodedFilePath = encodeURIComponent(filePath);
  return `${API_HOST}/proxy/telegram-photo?file_path=${encodedFilePath}`;
}

export const MAX_ROWS = 1000;

// Layout Cursor-like (CoursePage, LessonPage)
export const RIGHT_PANEL_WIDTH = 340;
export const LEFT_SIDEBAR_COURSE = 280;
export const LEFT_SIDEBAR_LESSON = 320;

// Цветовая палитра на основе BRAND_IDENTITY.md
export const BRAND_COLORS = {
  primary: '#0abf53',      // Яркий зелёный
  accent: '#d7f5e3',       // Бледный светло-зелёный
  accentForeground: '#067934', // Темный лесной зелёный
  secondary: '#f7f7f8',    // Очень светлый серый
  text: '#00112c',         // Очень темный синий
  bg: '#FFFFFF',          // Чистый Белый
} as const;

/** Яркая палитра доменов (используется в редакторе задачи, TaskPanel) */
export const DOMAIN_COLOR_PALETTE = [
  "bg-blue-50 text-blue-700 border border-blue-200",
  "bg-purple-50 text-purple-700 border border-purple-200",
  "bg-indigo-50 text-indigo-700 border border-indigo-200",
  "bg-pink-50 text-pink-700 border border-pink-200",
  "bg-orange-50 text-orange-700 border border-orange-200",
  "bg-amber-50 text-amber-700 border border-amber-200",
  "bg-cyan-50 text-cyan-700 border border-cyan-200",
  "bg-violet-50 text-violet-700 border border-violet-200",
];

/** Приглушённая палитра доменов для списка задач (без яркого акцента) */
export const DOMAIN_COLOR_PALETTE_MUTED = [
  "bg-neutral-100 text-neutral-700 border border-neutral-200",
  "bg-slate-100 text-slate-700 border border-slate-200",
  "bg-stone-100 text-stone-700 border border-stone-200",
  "bg-zinc-100 text-zinc-700 border border-zinc-200",
  "bg-neutral-100 text-neutral-600 border border-neutral-200",
  "bg-slate-100 text-slate-600 border border-slate-200",
  "bg-stone-100 text-stone-600 border border-stone-200",
  "bg-zinc-100 text-zinc-600 border border-zinc-200",
];
